import React from 'react';

/**
 * Renders text that may be plain or HTML (from the admin WYSIWYG editor).
 * Strips <script> tags for safety. Plain text is rendered as a normal paragraph.
 */
const HTML_TAG_RE = /<\/?[a-z][\s\S]*>/i;

const stripScripts = (html) =>
  String(html)
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    // Convert non-breaking spaces back to regular spaces so text wraps naturally
    .replace(/(&nbsp;|\u00A0)/g, ' ');

export const RichText = ({ html, className = '', as: As = 'div', plainClass = '' }) => {
  if (!html) return null;
  const cleaned = stripScripts(html);
  const isHtml = HTML_TAG_RE.test(cleaned);
  if (!isHtml) {
    return <As className={plainClass || className}>{cleaned}</As>;
  }
  return (
    <As
      className={`rich-text-content ${className}`}
      dangerouslySetInnerHTML={{ __html: cleaned }}
    />
  );
};

export default RichText;
